import { loadScript, removeScripts } from 'common-utils';

import { TrackingTool } from '../tracking-tool';

declare global {
  interface Window {
    // eslint-disable-next-line
    twq: any;
  }
}

async function addTwitterConversionCode() {
  if (typeof window !== 'undefined') {
    window.twq('event', 'tw-oeivj-oeivk', {});
  }
}

export class Twitter implements TrackingTool {
  private readonly _id: string;

  constructor(id: string) {
    this._id = id;
  }

  getName(): string {
    return 'twitter';
  }

  async turnOff() {
    removeScripts(['https://static.ads-twitter.com/uwt.js']);
  }

  async turnOn() {
    if (typeof window !== 'undefined') {
      window.twq = function () {
        window.twq.exe
          ? window.twq.exe.apply(window.twq, [...arguments])
          : window.twq.queue.push(arguments);
      };
      window.twq.version = '1.1';
      window.twq.queue = [];
      window.twq('config', this._id);
      const src = 'https://static.ads-twitter.com/uwt.js';
      await loadScript(src);
    }
  }

  trackSpecialEvent = {
    onUserCreated: addTwitterConversionCode,
  };
}
